import React, { useEffect, useState } from 'react';
import './MachineLearning.css';
import UseData from '../../../Hooks/UseData';
import MProjects from './MProjects';
const MachineLearning = () => {
    const [mprojects, setmProjects] = useState([]);
    useEffect(() => {
        fetch('datam.json')
            .then(res => res.json())
            .then(data => setmProjects(data))
    }, []);
    return (
        <div className=" web-project-container" style={{ backgroundColor: '#121212' }}>
            <div class="row row-cols-1 container mx-auto row-cols-md-2 g-4">
                {
                    mprojects.map(mproject => <MProjects mproject={mproject} key={Math.floor(Math.random() * 1000000000000000)}></MProjects>)
                }
            </div>
        </div>
    );
};

export default MachineLearning;